{
  "title": "是否允許存取您的位置？",
  "body": "允許存取您的位置，可協助我們確認您已抵達設施進行報到",
  "disagree": "不同意",
  "agree": "同意"
}
